<ng-container *transloco="let t">
<ion-card-content class="h-100 p-2 user-card-content">
  <ion-grid class="card h-100 user-card"
            [class.role-dominant]="selectedProfile().role === 0"
            [class.role-sub]="selectedProfile().role === 1"
            [class.role-switch]="selectedProfile().role === 2">
    <ion-row class="card-header">
	    @if (compatibilityScore() !== null && selectedProfile().uuid !== profile().uuid) {
		    <div class="compat-gauge" title="{{t('profile.compatibility_score')}}"
		         [style.--compat]="compatibilityScore()">
			    <svg viewBox="0 0 36 36" aria-hidden="true">
				    <circle class="gauge-track" cx="18" cy="18" r="14"></circle>
				    <circle class="gauge-value" cx="18" cy="18" r="14"></circle>
			    </svg>
			    <span class="gauge-text">{{ compatibilityScore() }}%</span>
		    </div>
	    }
      <ion-row class="d-flex flex-nowrap w-100">
        <ion-col class="my-thin-col">
          @if (selectedProfile()) {
	          <button
		          type="button"
		          class="avatar-action"
		          (click)="navigateToBigProfile()"
		          [attr.aria-label]="t('Show full profile of') + ' ' + selectedProfile().username"
		          [title]="t('Show full profile of') + ' ' + selectedProfile().username">
		          <app-avatar
			          [src]="selectedProfile().imgUrl"
			          [alt]="selectedProfile().username + ' user avatar'"
			          [initials]="getInitials(selectedProfile().username)"
			          [size]="100"
		          ></app-avatar>
	          </button>
          }
        </ion-col>
        <ion-col>
          <ion-row>
            <span class="online text-center me-1 mt-auto mb-auto">
              @if (selectedProfile()) {
	              <ion-icon [ngClass]="{
                  'is-online':  presenceStatus() === 'online',
                  'is-offline': presenceStatus() === 'offline',
                  'is-away': presenceStatus() === 'away'}" class="is-offline" name="ellipse"></ion-icon>
              }
            </span>
            <h2 class="profile-name">
	            <button
		            type="button"
		            class="profile-link-btn"
		            (click)="navigateToBigProfile()"
		            [attr.aria-label]="t('Show full profile of') + ' ' + selectedProfile().username"
		            [title]="t('Show full profile of') + ' ' + selectedProfile().username">
	              @if (selectedProfile() && selectedProfile().username) {
		              @if (selectedProfile().username.length > 16) {
			              {{ selectedProfile().username | slice : 0 : 16 }}{{ '...' }}
		              } @else {
			              {{ selectedProfile().username }}
		              }
		              <span class="astro-label"><span
			              [class]="astro2LabelMapping[selectedProfile().astroSign]">{{t('Astro.' + astro2LabelMapping[selectedProfile().astroSign])}}</span></span>
	              }
	            </button>
            </h2>
          </ion-row>
	        @if (selectedProfile().gender) {
		        <ion-row>
              <span
	              class="me-auto d-flex">{{t("gender." + gender2LabelMapping[selectedProfile().gender])}}
		              <ion-text>
			              @if (selectedProfile().pronoun.length) {
				              (
			              @for (p of selectedProfile().pronoun; track p; let last = $last) {
					              {{t("pronoun." + pronouns2LabelMapping[p])}}{{ last ? '' : ',' }}
				              }
				              )
			              }
		              </ion-text>
		              @if (selectedProfile().transPeople) {
		              <img alt="Transgender flag" class="title-image trans-flag" height="20"
		                   [ngSrc]="'assets/icons/transFlag.svg'"
		                   width="20"/>
	              }
	              {{ selectedProfile().age }} {{t("yearsold")}}
              </span>
            </ion-row>
	        }
	        @if (selectedProfile().role !== null) {
		        <ion-row>
              <span class="me-auto">{{t("roles." + roles2LabelMapping[selectedProfile().role])}}</span>
            </ion-row>
	        }
        </ion-col>
      </ion-row>
      <div class="w-100 mt-3 d-flex location-actions">
        <span class="location-text">
	        @if (selectedProfile().pays + '' !== '') {
		        <span>{{selectedProfile().region}}{{selectedProfile().region !== '' ? ', ' : ''}}{{t("country." + selectedProfile().pays)}}</span>
        }</span>
	        <div class="card-actions">
	        <button type="button" (click)="navigateToBigProfile()" class="m-1 span-icon"
	              [attr.aria-label]="t('Show full user profile')"
	              [title]="t('Show full user profile')">
            <ion-icon class="red-text icon-static" name="person-outline"></ion-icon>
          </button>
          @if (currentProfile() && selectedProfile().uuid !== currentProfile()!.uuid) {
	          <button type="button" (click)="sendPrivateMessage(selectedProfile())" class="m-1 span-icon action-btn action-btn--message"
	                [attr.aria-label]="t('Send message to user')" [title]="t('Send message to user')">
              <ion-icon class="red-text icon-static" name="mail-outline"></ion-icon>
	          </button>
		        @if (!isFavorite()) {
			        <button type="button" (click)="addUserFavorit()" class="m-1 span-icon"
			              [attr.aria-label]="t('Add user to favorites')" [title]="t('Add user to favorites')">
                <ion-icon class="red-text icon-static" name="star-outline"></ion-icon>
			        </button>
		        }
		        @if (isFavorite()) {
			        <button type="button" (click)="removeUserFavorit()" class="m-1 span-icon"
			              [attr.aria-label]="t('Remove user from favorites')" [title]="t('Remove user from favorites')">
                <ion-icon class="star-color icon-static" name="star"></ion-icon>
			        </button>
		        }
		        @if (!isBlocked()) {
			        <button type="button" (click)="blockUser()" class="m-1 span-icon"
			              [attr.aria-label]="t('Block user')" [title]="t('Block user')">
                <ion-icon [icon]="'ban-outline'" class="red-text icon-static"></ion-icon>
			        </button>
		        }
		        @if (isBlocked()) {
			        <button type="button" (click)="unblockUser()" class="m-1 span-icon"
			              [attr.aria-label]="t('Unblock user')" [title]="t('Unblock user')">
                <ion-icon name="ban-outline" class="icon-muted icon-static"></ion-icon>
			        </button>
		        }
		        @if (currentProfile()!.scope === 'Admin') {
			        <button type="button" (click)="deleteUser()" class="m-1 span-icon" aria-label="Delete" title="Delete">
                <ion-icon name="trash-outline" class="icon-muted icon-static"></ion-icon>
			        </button>
		        }
          }
        </div>
      </div>
    </ion-row>
    <ion-row class="card-body">
      "{{selectedProfile().shortDesc ? selectedProfile().shortDesc : t('profile.default_mood') }}"
    </ion-row>
  </ion-grid>
</ion-card-content>

</ng-container>
